import { collection, doc, getDocs, query, where, orderBy, writeBatch, setDoc, Timestamp } from "firebase/firestore";
import { db } from "../firebase";
import { COLLECTIONS } from "../collections";

/**
 * Salva o lessonPlan nas sessões via batch update.
 * @returns {number} Total de sessões atualizadas
 */
export const savePlan = async (idTenant, sessionsWithPlan) => {
    if (!idTenant || !sessionsWithPlan.length) return 0;

    const BATCH_LIMIT = 499;
    let totalUpdated = 0;

    for (let i = 0; i < sessionsWithPlan.length; i += BATCH_LIMIT) {
        const chunk = sessionsWithPlan.slice(i, i + BATCH_LIMIT);
        const batch = writeBatch(db);

        chunk.forEach(session => {
            if (!session.id || !session.lessonPlan) return;
            const ref = doc(db, "tenants", idTenant, COLLECTIONS.SESSIONS, session.id);
            batch.update(ref, { lessonPlan: session.lessonPlan });
        });

        await batch.commit();
        totalUpdated += chunk.length;
    }

    return totalUpdated;
};

/**
 * Salva o ciclo de planejamento em planningCycles/{groupId}.
 * A Cloud Function generateDailySessions lê este documento para aplicar
 * o plano automaticamente em sessões recém-criadas.
 */
export const saveCycle = async (idTenant, classGroupId, cycle, metadata) => {
    const cycleDoc = doc(db, "tenants", idTenant, COLLECTIONS.PLANNING_CYCLES, classGroupId);
    await setDoc(cycleDoc, {
        idTenant,
        groupId: classGroupId,
        cycleLength: cycle.length,
        weeks: cycle.map((weekObjectives, idx) => ({
            position: idx + 1,
            objectives: weekObjectives
        })),
        anchorWeekKey: metadata.anchorWeekKey,
        evaluationEventId: metadata.evaluationEventId || "",
        classMemberCount: metadata.classMemberCount || 0,
        classAvgOverall: Math.round((metadata.classAvgOverall || 0) * 100) / 100,
        idEmployee: metadata.idEmployee || "",
        employeeName: metadata.employeeName || "",
        employeePhone: metadata.employeePhone || "",
        employeeEmail: metadata.employeeEmail || "",
        employeePhotoUrl: metadata.employeePhotoUrl || "",
        generatedAt: Timestamp.now(),
        updatedAt: Timestamp.now()
    });
};

/**
 * Busca sessões futuras de um conjunto de turmas.
 * @returns {Array} Sessões ordenadas por data
 */
export const getFutureSessions = async (idTenant, classIds) => {
    const todayISO = new Date().toISOString().slice(0, 10);
    const allSessions = [];

    for (const classId of classIds) {
        const q = query(
            collection(db, "tenants", idTenant, COLLECTIONS.SESSIONS),
            where("idClass", "==", classId),
            where("sessionDate", ">=", todayISO),
            orderBy("sessionDate", "asc")
        );
        const snap = await getDocs(q);
        snap.docs.forEach(d => allSessions.push({ id: d.id, ...d.data() }));
    }

    return allSessions;
};
